/**
 * Cookie utilities for client-side cookie management
 */

const ONBOARDING_SKIP_COOKIE = "b3os_onboarding_skipped";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year in seconds

/**
 * Set a cookie with the given name, value, and options
 */
export function setCookie(name: string, value: string, maxAge: number = COOKIE_MAX_AGE): void {
  if (typeof document === "undefined") return;

  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  const cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; max-age=${maxAge}; path=/; SameSite=Lax${secure}`;
  document.cookie = cookieString;
}

/**
 * Get a cookie value by name
 */
export function getCookie(name: string): string | null {
  if (typeof document === "undefined") return null;

  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [cookieName, ...cookieValues] = cookie.trim().split("=");
    if (cookieName && decodeURIComponent(cookieName) === name) {
      return decodeURIComponent(cookieValues.join("="));
    }
  }
  return null;
}

/**
 * Delete a cookie by name
 */
export function deleteCookie(name: string): void {
  if (typeof document === "undefined") return;

  document.cookie = `${encodeURIComponent(name)}=; max-age=0; path=/`;
}

/**
 * Check if the user has skipped onboarding
 */
export function hasSkippedOnboarding(): boolean {
  return getCookie(ONBOARDING_SKIP_COOKIE) === "true";
}

/**
 * Mark onboarding as skipped
 */
export function setOnboardingSkipped(): void {
  setCookie(ONBOARDING_SKIP_COOKIE, "true");
}

/**
 * Clear the onboarding skip status (for testing or if user wants to see onboarding again)
 */
export function clearOnboardingSkipped(): void {
  deleteCookie(ONBOARDING_SKIP_COOKIE);
}
